declare namespace $ {

	type $shm_hitalama_opencode_map_sessions__server_url_shm_hitalama_opencode_map_widget_session_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_widget_session['server_url'] >
		,
		ReturnType< $shm_hitalama_opencode_map_sessions['server_url'] >
	>
	type $shm_hitalama_opencode_map_sessions__map_id_shm_hitalama_opencode_map_widget_session_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_widget_session['map_id'] >
		,
		ReturnType< $shm_hitalama_opencode_map_sessions['map_id'] >
	>
	type $shm_hitalama_opencode_map_sessions__session_id_shm_hitalama_opencode_map_widget_session_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_widget_session['session_id'] >
		,
		ReturnType< $shm_hitalama_opencode_map_sessions['session_id'] >
	>
	type $shm_hitalama_opencode_map_sessions__new_session_model_shm_hitalama_opencode_map_widget_session_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_widget_session['new_session_model'] >
		,
		ReturnType< $shm_hitalama_opencode_map_sessions['new_session_model'] >
	>
	export class $shm_hitalama_opencode_map_widget_session extends $shm_hitalama_opencode_session {
		map_id( ): string
		session_id( next?: string ): string
		new_session_model( ): any
		events_native( ): any
		widget( ): $shm_hitalama_map_widget
		Map_page( ): $shm_hitalama_map_page
		Map_sessions( ): $shm_hitalama_opencode_map_sessions
		auto( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=session.view.tree.d.ts.map